export enum CoverageCartModificationKind {
  Count = "count",
  Price = "price",
  Discount = "discount",
}
